import { getConfiguration } from "./configuration";

export let getAnimationDuration = function() {
    const DEFAULT_DURATION = 4000;
    let duration = DEFAULT_DURATION;
    const livePollingInterval = getConfiguration()?.lpo ?? 0;
    if ((livePollingInterval - 500) > DEFAULT_DURATION) {
        duration = livePollingInterval - 500;
    }
    getAnimationDuration = () => duration;
}
